import { render, staticRenderFns } from "./PropertyDate.vue?vue&type=template&id=277b6c26&scoped=true"
import script from "./PropertyDate.vue?vue&type=script&lang=ts"
export * from "./PropertyDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277b6c26",
  null
  
)

export default component.exports